<template>
  <v-row>
    <v-col class="d-flex">
      <v-list-subheader>
        {{ t(translationKey) }}
      </v-list-subheader>
      <v-spacer />
      <v-list-subheader v-if="showPublishDate">
        {{ t('kodeverkTable.publishDate') }}
      </v-list-subheader>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
withDefaults(
  defineProps<{
    translationKey: string
    showPublishDate?: boolean
  }>(),
  { showPublishDate: true }
)
</script>
